import styled from 'styled-components'

export default styled.button`
    border-radius: 5px;
    border: none;
    background: rgba(0,0,0, .09);
    font-size: 1em;
    font-weight:bold;
    padding: 15px;

    display: flex;
    flex-direction: row;
    align-items: center;

    transition: all .3s ease-in-out;

    svg {
      margin-right: .5em;
    }

    &:focus {outline:0;}

    &:hover {
      background: rgba(0,0,0, .8);
      color: white;
      cursor: pointer;
    }
`;